// Stats.jsx
import { motion } from 'framer-motion';
import { STATS } from '../../data/siteData';
import AnimatedCounter from '../UI/AnimatedCounter';
import './Stats.css';

export default function Stats() {
  return (
    <section className="stats-strip section-alt">
      <div className="stats-strip__glow" />
      <div className="container stats-strip__grid">
        {STATS.map((s, i) => (
          <motion.div
            className="stats-strip__item"
            key={s.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
          >
            <span className="stats-strip__value">
              <AnimatedCounter value={s.value} suffix={s.suffix} />
            </span>
            <span className="stats-strip__label">{s.label}</span>
          </motion.div>
        ))}
      </div>
    </section>
  );
}